module.exports = __webpack_public_path__ + "media/images/mobile/logo/Group 554-8ca15fa76ee2b4fd7da1e772074a84b0.jpg";